import { idMigrationService } from './idMigrationService';

/**
 * ID 마이그레이션 실행 스크립트
 * 브라우저 콘솔에서 실행할 수 있는 전역 함수들
 */

// 전역 함수로 등록
declare global {
  interface Window {
    runIdMigration: (userId: string, classId: string) => Promise<void>;
    getMigrationResult: () => any;
  }
}

/**
 * ID 마이그레이션 실행
 * @param userId 사용자 ID
 * @param classId 클래스 ID
 */
export async function runIdMigration(userId: string, classId: string): Promise<void> {
  try {
    console.log('🚀 ID 마이그레이션 시작...');
    console.log(`사용자: ${userId}`);
    console.log(`클래스: ${classId}`);
    
    await idMigrationService.runIdMigration(userId, classId);
    
    const result = idMigrationService.getResult();
    console.log('📊 마이그레이션 결과:', result);
    
    if (result.success) {
      console.log('✅ ID 마이그레이션 성공!');
      console.log(`처리된 항목: ${result.processedCount}개`);
      console.log(`에러: ${result.errorCount}개`);
      console.log(`소요 시간: ${result.duration}ms`);
    } else {
      console.error('❌ ID 마이그레이션 실패');
      console.error('에러 목록:', result.errors);
    }
  } catch (error) {
    console.error('❌ ID 마이그레이션 실행 중 오류:', error);
  }
}

/**
 * 마이그레이션 결과 조회
 */
export function getMigrationResult() {
  return idMigrationService.getResult();
}

// 전역 함수로 등록
if (typeof window !== 'undefined') {
  window.runIdMigration = runIdMigration;
  window.getMigrationResult = getMigrationResult;
  
  console.log('🔧 ID 마이그레이션 함수가 전역으로 등록되었습니다.');
  console.log('사용법:');
  console.log('1. runIdMigration("userId", "classId") - ID 마이그레이션 실행');
  console.log('2. getMigrationResult() - 마이그레이션 결과 조회');
}
